import { createFileRoute } from '@tanstack/react-router'

import { EdgeHistoryRoute } from '@/pages/rewards/route-entries/edge-history'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/_private/app/rewards/edge-history')({
  component: EdgeHistoryRoute,
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('Edge History'),
        },
      ],
    }
  },
})
